'use strict';

$(function () {
    $(".wysiwyg").ckeditor();

    $('#show-tips').on('click', function () {
        $(this).closest('.page-tips').toggleClass('open');
    });

    $("section[data-pagetip]").each(function () {
        var $t = $(this);
        var cke = $t.find("article");
        cke.data("wysiwyg", cke.html());
        var editBtn = $t.find(".btn-info");
        var saveBtn = $t.find(".btn-success");
        saveBtn.hide();
        var cancelBtn = $t.find(".btn-warning");
        cancelBtn.hide();

        editBtn.click(function () {
            cke.ckeditor({ floatSpaceDockedOffsetY: 80 });
            cke.attr('contenteditable', true);
            cke.focus();
            editBtn.hide();
            saveBtn.show();
            cancelBtn.show();
        });

        cancelBtn.click(function () {
            cke.ckeditor().editor.destroy();
            cke.attr('contenteditable', false);
            cke.html(cke.data("wysiwyg"));
            editBtn.show();
            saveBtn.hide();
            cancelBtn.hide();
        });
        saveBtn.click(function () {
            abp.services.api.pageTip.insertOrUpdate({
                reference: $t.attr("data-pagetip"),
                content: cke.html()
            }).done(function (result) {
                cke.data("wysiwyg", cke.html());
                cke.ckeditor().editor.destroy();
                cke.attr('contenteditable', false);
                editBtn.show();
                saveBtn.hide();
                cancelBtn.hide();
                abp.notify.success(abp.localization.localize("Common:PageTipSaved", 'Default'));
            }).fail(function (result) {
                abp.notify.error(abp.localization.localize("Common:AjaxError", 'Default'));
            });
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/editor.js
// module id = 918
// module chunks = 0